import { Component, OnInit} from "@angular/core";
import "moment/locale/es";
import { Router } from "@angular/router";
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';


@Component({
	selector: "app-google-calendar",
	templateUrl: "./google-calendar.component.html",
	styleUrls: ["./google-calendar.component.scss"],
})
export class GoogleCalendarComponent implements OnInit {
	url : SafeUrl;

	constructor(
		private sanitizer: DomSanitizer,
		public router: Router
	) {
	}

	ngOnInit(): void {
		this.url = this.sanitizer.bypassSecurityTrustResourceUrl("https://calendar.google.com/calendar/u/0/embed?src=kominplis@gmail.com&ctz=Europe/Madrid");
	}

}
